/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserRole } from './userRole';
import type { CourseStudentState } from './courseStudentState';
import type { CourseStudentTitle } from './courseStudentTitle';
import type { CourseStudentTrial } from './courseStudentTrial';
import type { CourseStudentCohort } from './courseStudentCohort';
import type { CourseStudentContext } from './courseStudentContext';
import type { CourseStudentAvatar } from './courseStudentAvatar';
import type { CourseStudentProfilePhotoBlobPath } from './courseStudentProfilePhotoBlobPath';
import type { CourseStudentFeatures } from './courseStudentFeatures';
import type { CourseStudentExternalStudentId } from './courseStudentExternalStudentId';
import type { UserNotificationPreferences } from './userNotificationPreferences';
import type { CourseStudentOrderId } from './courseStudentOrderId';
import type { CourseStudentAccessibleModuleIds } from './courseStudentAccessibleModuleIds';
import type { IdTitleReference } from './idTitleReference';

/**
 * student in course
 */
export interface CourseStudent {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  role: UserRole;
  state?: CourseStudentState;
  active?: boolean;
  title?: CourseStudentTitle;
  trial?: CourseStudentTrial;
  cohort?: CourseStudentCohort;
  context?: CourseStudentContext;
  avatar?: CourseStudentAvatar;
  profilePhotoBlobPath?: CourseStudentProfilePhotoBlobPath;
  features?: CourseStudentFeatures;
  externalStudentId?: CourseStudentExternalStudentId;
  id: string;
  notificationPrefs?: UserNotificationPreferences;
  enrollmentDate: string;
  orderId?: CourseStudentOrderId;
  accessibleModuleIds?: CourseStudentAccessibleModuleIds;
  extraModuleIds?: string[];
  extraModules?: IdTitleReference[];
}
